export const manifest = {
  screens: {
    scr_iwmspu: { name: "Start Your Move-Out", route: "/", state: {"currentStep":0}, position: {"x":160,"y":220} },
    scr_z4nsmy: { name: "Lease Payment", route: "/", state: {"currentStep":1}, position: {"x":1560,"y":220} },
    scr_6mmcl2: { name: "Payment Confirmed", route: "/", state: {"currentStep":2}, position: {"x":2960,"y":220} },
    scr_naezhj: { name: "Signature", route: "/", state: {"currentStep":3}, position: {"x":4309.06,"y":168.42} },
    scr_kuw70c: { name: "Schedule Inspection", route: "/", state: {"currentStep":4}, position: {"x":5682.06,"y":170.19} },
    scr_u7zoww: { name: "Inspection Confirmed", route: "/", state: {"currentStep":5}, position: {"x":7180.78,"y":205.93} },
  },
  sections: {
    sec_u89sb2: { name: "Move-Out Process", x: 0, y: 0, width: 8520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_u89sb2", children: [
      { kind: "screen", id: "scr_iwmspu" },
      { kind: "screen", id: "scr_z4nsmy" },
      { kind: "screen", id: "scr_6mmcl2" },
      { kind: "screen", id: "scr_kuw70c" },
      { kind: "screen", id: "scr_u7zoww" },
      { kind: "screen", id: "scr_naezhj" },
    ] },
  ],
}
